module.exports = require("core-js/library/fn/object/get-own-property-descriptor");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/get-own-property-descriptor.js
// module id = 119
// module chunks = 35783957827783 52252321336229